import { ReactElement } from 'react';
import RichText from 'components/UI/Richtext';
import { IComponentTextWithIconsBeneathFields } from 'types/contentful';
import { Asset } from 'contentful';
import Image from 'components/UI/Image';
import CTA from 'components/UI/Cta';
import { LINK_CONTENT_TYPE } from 'lib/consts';
import IFrameCTA from 'components/UI/IFrameCta';

const ICON_SIZE_CONFIG = {
  Small: { wrapper: 'w-16', query: 'w=64' },
  Medium: { wrapper: 'w-24', query: 'w=96' },
  Large: { wrapper: 'w-32', query: 'w=128' },
  XLarge: { wrapper: 'w-48', query: 'w=160' },
  '2XL': { wrapper: 'w-64', query: 'w=256' },
} as const;

export default function TextWithIconsBeneath({
  heading,
  body,
  icons,
  iconSize = 'Medium',
  ctas,
}: IComponentTextWithIconsBeneathFields): ReactElement {
  const { wrapper, query } =
    ICON_SIZE_CONFIG[iconSize as keyof typeof ICON_SIZE_CONFIG] ?? ICON_SIZE_CONFIG.Medium;

  return (
    <div>
      <div className={`ecp-my text-primary-actual mx-auto px-site-component pb-10 md:pb-20`}>
        {heading && (
          <h2 className="font-light textext-new-34 lg:text-4xl lg:leading-new-43 text-center">
            {heading}
          </h2>
        )}

        <div className="">
          {body && (
            <div className={`mt-1 text-lg`}>
              <RichText document={body} classNames="text-lg text-primary-actual text-center" />
            </div>
          )}

          <div className="flex flex-row justify-center w-full mt-5 space-x-10">
            {icons?.map((icon, index) => (
              <div key={index} className={`mx-1 ${wrapper}`}>
                <Image
                  image={icon as Asset}
                  query={query}
                  classNames="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {ctas && ctas.length > 0 && (
            <div className="mt-8 flex flex-col items-center justify-center w-full space-y-4 md:flex-row md:space-y-0 md:space-x-6">
              {ctas.map((cta, index) => {
                const linkContentType = cta.sys.contentType.sys.id;
                if (linkContentType === LINK_CONTENT_TYPE.fragmentIFrameCta) {
                  return (
                    <div key={cta.sys.id ?? index}>
                      <IFrameCTA
                        {...cta.fields}
                        backgroundColor="black"
                        classNames="w-full md:w-auto"
                      />
                    </div>
                  );
                }
                return (
                  <div key={cta.sys.id ?? index}>
                    <CTA {...cta.fields} classNames="w-full md:w-auto" />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
